module.exports = __webpack_public_path__ + "static/MCIngo-f0ca7ec33ce99a6ffcc0f57923bcf0ab.png";